export default "__VITE_ASSET__DhxMvGSp__"